import { Layout } from 'react-feather';

import BlogIcon from '../../public/platforms/Blog.svg';
import InstagramIcon from '../../public/platforms/instagram.svg';
import LinkedInIcon from '../../public/platforms/linkedin.svg';
import MediumIcon from '../../public/platforms/Medium.svg';
import NoPlatformIcon from '../../public/platforms/Content.svg';
import SnapchatIcon from '../../public/platforms/Snapchat.svg';
import SpotifyIcon from '../../public/platforms/Spotify.svg';
import TikTokIcon from '../../public/platforms/tiktok.svg';
import TwitchIcon from '../../public/platforms/Twitch.svg';
import TwitterIcon from '../../public/platforms/X.svg';
import YouTubeIcon from '../../public/platforms/youtube.svg';
import CTVIcon from '../../public/platforms/CTV.svg';
import DOOHIcon from '../../public/platforms/DOOH.svg';
import AudioAdsIcon from '../../public/platforms/Audio_ads.svg';
import DisplayAdsIcon from '../../public/platforms/DisplayAds.svg';
import VideoAdsIcon from '../../public/platforms/Video_ads.svg';

import IconPdf from '../../public/assets/icons/formats/pdf.svg';
import IconPpt from '../../public/assets/icons/formats/ppt.svg';
import IconTxt from '../../public/assets/icons/formats/txt.svg';
import IconOther from '../../public/assets/icons/formats/random.svg';

export function PlatformIcon(platform: string | undefined, size = 28) {
  switch (platform) {
    case 'BLOG':
      return <BlogIcon />;
    case 'BLOG_POST':
      return <Layout size={size} />;
    case 'INSTAGRAM':
      return <InstagramIcon />;
    case 'LINKEDIN':
      return <LinkedInIcon />;
    case 'TIKTOK':
      return <TikTokIcon />;
    case 'YOUTUBE':
      return <YouTubeIcon />;
    case 'TWITCH':
      return <TwitchIcon />;
    case 'TWITTER':
      return <TwitterIcon />;
    case 'SNAPCHAT':
      return <SnapchatIcon />;
    case 'SPOTIFY':
      return <SpotifyIcon />;
    case 'MEDIUM':
      return <MediumIcon />;
    case 'CTV':
      return <CTVIcon />;
    case 'DOOH':
      return <DOOHIcon />;
    case 'AUDIO_ADS':
      return <AudioAdsIcon />;
    case 'DISPLAY_ADS':
      return <DisplayAdsIcon />;
    case 'VIDEO_ADS':
      return <VideoAdsIcon />;
    default:
      return <NoPlatformIcon />;
  }
}

export const getFileIcon = (filename: string) => {
  const lowerCaseFilename = filename.toLowerCase();

  if (lowerCaseFilename.endsWith('.pdf')) {
    return <IconPdf />;
  }
  if (lowerCaseFilename.endsWith('.ppt') || lowerCaseFilename.endsWith('.pptx')) {
    return <IconPpt />;
  }
  if (lowerCaseFilename.endsWith('.txt')) {
    return <IconTxt />;
  }
  return <IconOther />;
};
